<template>
  <FormationDetailLayout
    lesson="Formation Taxi Continue"
    back-item="formation-taxi"
    :hero-image="heroImage"
    hero-alt="time-laps-car-turn"
    hero-eyebrow="Renouvellement carte taxi"
    hero-title="TAXI CONTINUE"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>Formation taxi continue</h2>

        <div class="formation-flow">
          <p>
            L'Institut Taxi propose la
            <strong
              >formation continue obligatoire pour les chauffeurs de
              taxi</strong
            >
            titulaires d'une <strong>carte professionnelle</strong>. Cette
            <strong>formation</strong>, d'une durée de 14 heures, permet aux
            chauffeurs de se maintenir à jour avec la réglementation en vigueur.
            Elle se compose de quatre modules : le
            <strong>droit du transport public particulier de personnes</strong>,
            les réglementations spécifiques à l'activité de taxi, la sécurité
            routière et la gestion. Grâce à cette
            <strong>formation continue</strong>, les
            <strong>chauffeurs de taxi</strong> peuvent exercer leur métier avec
            compétence et professionnalisme.
          </p>
        </div>
      </article>

      <article class="formation-section formation-section--theory">
        <h2>Renouvellement carte professionnelle taxi</h2>

        <div class="formation-panel">
          <h3>4 MODULES</h3>

          <ul class="formation-list">
            <li>A – Droit du transport public particuliers de personnes</li>
            <li>B – Réglementation spécifique lié à l’activité de taxi</li>
            <li>C – Sécurité Routière</li>
            <li>D – Gestion</li>
          </ul>

          <div class="formation-panel__footer">
            <p>3h30 par module</p>
          </div>
        </div>
      </article>

      <article class="formation-section formation-section--t3p">
        <h2>
          Faire une demande de renouvellement de la carte professionnelle de
          taxi
        </h2>

        <div class="formation-flow">
          <p>
            Pour <strong>renouveler sa carte professionnelle de taxi</strong>,
            il est nécessaire de suivre une <strong>formation continue</strong>.
            Cette <strong>formation</strong> a une durée de 14 heures et doit
            être effectuée tous les cinq ans. Elle vise à mettre à jour les
            connaissances des chauffeurs sur des sujets tels que le droit du
            <strong>transport public particulier de personnes</strong>, les
            réglementations spécifiques à l'<strong>activité de taxi</strong>,
            la sécurité routière et la gestion.
          </p>

          <p>
            Pour cela, les chauffeurs doivent s'inscrire auprès d'un
            <strong>centre de formation agréé</strong>, comme l'Institut Taxi.
            Pendant la <strong>formation</strong>, ils participent activement
            aux sessions animées par des formateurs qualifiés. À la fin de la
            <strong>formation</strong>, une évaluation ou un test est réalisé
            pour valider les acquis des chauffeurs.
          </p>

          <p>
            Une fois la <strong>formation</strong> réussie, les chauffeurs
            peuvent entamer les démarches de renouvellement de leur
            <strong>carte professionnelle de taxi</strong>. Ils doivent fournir
            les documents requis, tels que le certificat de formation, aux
            autorités compétentes chargées du renouvellement des cartes.
          </p>

          <p>
            Le
            <strong>renouvellement de sa carte professionnelle de taxi</strong>
            est essentiel pour rester à jour sur les réglementations en vigueur
            et assurer un service de qualité aux passagers. C'est une étape
            importante pour les chauffeurs afin de maintenir leurs compétences
            et continuer à exercer leur profession de manière responsable et
            professionnelle.
          </p>
        </div>
      </article>
    </template>
  </FormationDetailLayout>
</template>

<script>
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/formation-taxi-continue.webp");
const heroStats = [
  { label: "Prix", value: "229€" },
  { label: "Durée", value: "14h / 2 jours" },
];

export default {
  name: "TaxiContinue",
  components: { FormationDetailLayout },
  setup() {
    useMeta({
      title: "Formation continue taxi",
      description: [
        {
          content:
            "Suivez notre formation continue Taxi pour rester à jour sur la réglementation en vigueur, les nouvelles technologies, les bonnes pratiques de service client et bien plus encore. Améliorez vos compétences en tant que chauffeur de taxi expérimenté.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-taxi-continue",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
